import { defineMessages } from 'react-intl';

export default defineMessages({
  counter: {
    id: 'marketHome.counter',
    defaultMessage: `{count} {count, plural,
        one {experience}
        other {experiences}
    }`,
  },
  seeMoreExperiences: {
    id: 'marketHome.seeMoreExperiences',
    defaultMessage: 'See more experiences',
  },
  noResultsTitle: {
    id: 'filtered.noResults.noResultsTitle',
    defaultMessage: 'No experiences',
  },
  noResultsDescription: {
    id: 'filtered.noResults.noResultsDescription',
    defaultMessage:
      'Sorry, none of our experiences match what you’re looking for. Try adjusting your filters or contact ' +
      '<a href="mailto:support@winnow.life">support@winnow.life</a> where one of our advisors may be able to assist.',
  },
});
